import { Navbar } from '@typedream/core';
import { isEqualWith } from 'lodash';
import contentComparator from './contentComparator';

const isNavbarEqual = (a: Navbar, b: Navbar): boolean => isEqualWith(a, b, contentComparator);

export default isNavbarEqual;
